import styled from 'styled-components';
import { rgba } from 'polished';
import { primary, neutral, white, success, warning, error, info } from '../../../../style/colors';

export const StickyFooter = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: ${white};
  border-top: 2px solid ${neutral[200]};
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.98);
`;

export const Container = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 16px 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;

  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: stretch;
    padding: 16px 20px;
    gap: 16px;
  }
`;

export const ProductInfo = styled.div`
  flex: 1;
  min-width: 0;

  @media (max-width: 1024px) {
    flex: none;
  }
`;

export const ProductName = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${neutral[900]};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 2px;

  @media (max-width: 1024px) {
    font-size: 15px;
  }
`;

export const CatalogNumber = styled.div`
  font-size: 13px;
  color: ${neutral[500]};
`;

export const Dimensions = styled.div`
  font-size: 13px;
  color: ${neutral[400]};
  font-weight: 500;
  margin-top: 2px;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;

  @media (max-width: 1024px) {
    flex-direction: column;
    gap: 12px;
    width: 100%;
  }
`;

export const DeliveryInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;

  @media (max-width: 1024px) {
    width: 100%;
    justify-content: space-between;
  }
`;

export const StockIndicator = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 600;
  padding: 6px 12px;
  border-radius: 20px;
  background: ${props => {
    if (props.color === 'green') return success.light;
    if (props.color === 'orange') return warning.light;
    return error.light;
  }};
  color: ${props => {
    if (props.color === 'green') return success.dark;
    if (props.color === 'orange') return warning.dark;
    return error.dark;
  }};

  i {
    font-size: 16px;
  }

  @media (max-width: 1024px) {
    font-size: 13px;
  }
`;

export const DeliveryLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: ${neutral[500]};

  i {
    font-size: 18px;
    color: ${primary[500]};
  }

  @media (max-width: 1024px) {
    font-size: 13px;
  }
`;

export const DeliveryDate = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${neutral[900]};

  @media (max-width: 1024px) {
    font-size: 13px;
  }
`;

export const DeliveryScheduleContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 10px 14px;
  background: ${info.light};
  border-radius: 8px;
  border: 1px solid ${info.base};
`;

export const DeliveryScheduleIcon = styled.div`
  color: ${info.dark};
  font-size: 20px;
  display: flex;
  align-items: center;
  margin-top: 2px;
`;

export const DeliveryScheduleWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const DeliveryScheduleHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const DeliveryScheduleTitle = styled.div`
  font-size: 10px;
  font-weight: 600;
  color: ${info.dark};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const DeliveryScheduleList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const DeliveryScheduleItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: ${info.base};
  font-weight: 500;
  padding: 4px 8px;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 4px;

  .quantity {
    font-weight: 700;
    min-width: 20px;
    color: ${info.dark};
  }

  .separator {
    color: ${neutral[300]};
  }

  .date {
    font-weight: 600;
    color: ${info.dark};
  }
`;

export const RefreshButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
  color: ${info.base};
  font-size: 14px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;

  &:hover {
    background: ${rgba(info.base, 0.1)};
    transform: rotate(180deg);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }

  &.spinning i {
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
`;

export const QuantitySection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  @media (max-width: 1024px) {
    width: 100%;
  }
`;

export const QuantityLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: ${neutral[500]};
`;

export const QuantityInput = styled.input`
  width: 70px;
  height: 42px;
  border: 2px solid ${neutral[200]};
  border-radius: 8px;
  padding: 0 12px;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  color: ${neutral[900]};
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: ${primary[500]};
    box-shadow: 0 0 0 3px ${rgba(primary[500], 0.1)};
  }

  &:disabled {
    background: ${neutral[100]};
    cursor: not-allowed;
  }

  /* Remove spinner buttons */
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  -moz-appearance: textfield;

  @media (max-width: 1024px) {
    flex: 1;
  }
`;

export const AddToCartButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: ${primary[500]};
  color: ${white};
  border: none;
  border-radius: 8px;
  padding: 12px 32px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  box-shadow: 0 2px 8px ${rgba(primary[500], 0.3)};

  i {
    font-size: 20px;
  }

  &:hover:not(:disabled) {
    background: ${primary[400]};
    box-shadow: 0 4px 12px ${rgba(primary[500], 0.4)};
    transform: translateY(-1px);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
    box-shadow: 0 2px 6px ${rgba(primary[500], 0.3)};
  }

  &:disabled {
    background: ${neutral[300]};
    cursor: not-allowed;
    box-shadow: none;
    opacity: 0.6;
  }

  @media (max-width: 1024px) {
    width: 100%;
    padding: 14px 32px;
  }
`;
